import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import common from './modules/common'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
import workflow from './modules/workflow'
import mediaPreview from './modules/mediaPreview'
import uploadStore from './modules/uploadStore'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    nodeMap: new Map(),
    isEdit: null,
    selectedNode: {},
    selectFormItem: null,
    design: {}
  },
  mutations: {
    selectedNode(state, val) {
      state.selectedNode = val
    },
    loadForm(state, val) {
      state.design = val
    },
    setIsEdit(state, val) {
      state.isEdit = val
    }
  },
  modules: {
    app,
    settings,
    user,
    common,
    permission,
    tagsView,
    workflow,
    mediaPreview,
    uploadStore
  },
  getters
})

export default store
